{{ highlightGroup()?.title }}
@for (highlight of highlightGroup()?.highlights; track highlight.title) {
  <a class="menu-item" [routerLink]="highlight.link.cached_url">
    {{ highlight.title }}
  </a>
}
